
import React from 'react'
import { Alert, ListGroup } from 'react-bootstrap'

import { usePlan } from '@/Hooks/UsePlan'
import { useProgrammation } from '@/Hooks/UseProgrammation'
import useTranslation from '@/Hooks/UseTranslation'

import { Can } from '@/Casl/Casl'

import ContentBlock from '../../components/ContentBlock'
import DocumentsUploader from './DocumentsUploader'
import DocumentItem from './DocumentItem'

const Documents = () => {

  const { t } = useTranslation()

  const { plan } = usePlan()

  const { itemOpened } = useProgrammation()

  return (
    <ContentBlock
      title={t('PROGRAMMATION_MANAGER:SectionDocumentsTitle') + ` (${itemOpened.documents.length})`}
      collapsable
      isCollapsed
    >
      <Can not do='upload' on='Documents' ability={plan} >
        <Alert variant="warning">
          {t('DOCUMENTS:NotAllowed')}
        </Alert>
      </Can>
      <Can do='upload' on='Documents' ability={plan}>
        <div style={{ textAlign: 'right' }}>
          <DocumentsUploader />
        </div>
      </Can>
      <Can do='download' on='Documents' ability={plan}>
        <ListGroup>
          {itemOpened.documents?.map((d: any) => (
            <DocumentItem key={d._id}
              document={d}
              canDelete={plan.can('remove', 'Document')}
            />
          ))}
        </ListGroup>
      </Can>
    </ContentBlock>
  )
}

export default Documents
